<div class="panel-body padding-sm-hr">
  <div [hidden]="formMode">
    <div class="row padding-sm-vr">
      <div class="col-sm-6">
        <label class="cursor-pointer">
          <input type="checkbox" name="showHistory" [(ngModel)]="showHistory" (change)="getHcpBrandClasses()" />
          {{'hco.showHistory' | translate}}
        </label>
      </div>
      <div class="col-sm-6 text-right cursor-pointer" (click)="showSaveModal()">
        <span class="margin-right-7 create-new-span">{{'hco.createNewClass' | translate }}</span>
        <i class="fa fa-plus-circle"></i>
      </div>
    </div>

    <div class="row padding-sm-vr">
      <div class="col-sm-12">
        <table class="table table-bordered">
          <thead>
            <tr>
              <th class="table-edit">{{'hco.businessUnit' | translate}}</th>
              <th class="table-edit">{{'hco.class' | translate}}</th>
              <th class="table-edit">{{'hco.startDate' | translate}}</th>
              <th class="table-edit">{{'hco.endDate' | translate}}</th>
              <th width="10%" style="text-align:center" class="table-edit">{{'app.edit' | translate}}</th>
              <th width="10%" style="text-align:center" class="table-edit">{{'app.delete' | translate}}</th>
            </tr>
          </thead>
          <tbody *ngIf="hcpBrandClasses.length>0 && displayMode==2">
            <tr *ngFor="let item of hcpBrandClasses" [class.text-muted]="item.endDate">
              <td>{{ item.businessUnitName }}</td>
              <td>{{ item.className }}</td>
              <td>{{ item.startDate | date:'yyyy-MM-dd' }}</td>
              <td>
                <span *ngIf="!item.endDate" class="label label-success">{{'hco.current' | translate}}</span>
                <span *ngIf="item.endDate">{{ item.endDate | date:'yyyy-MM-dd' }}</span>
              </td>
              <td style="text-align:center">
                <a href="javascript:;" (click)="edit(item)"><i class="fa fa-edit fa-lg font-size-20"></i></a>
              </td>
              <td style="text-align:center">
                <a href="javascript:;" (click)="confirmDelete(item)"><i class="fa fa-trash-o fa-lg font-size-20"></i></a>
              </td>
            </tr>
          </tbody>
          <tbody *ngIf="hcpBrandClasses.length==0 && displayMode==2">
            <tr>
              <td colspan="6">{{'app.NoDataFound' | translate}}</td>
            </tr>
          </tbody>
          <tbody *ngIf="displayMode==1">
            <tr>
              <td colspan="6">
                <div class="text-center padding-sm-vr">
                  <i class="fa fa-spinner fa-spin" style="font-size:48px;color:darkseagreen"></i> <p>{{'app.Loading' | translate}}</p>
                </div>
              </td>
            </tr>
          </tbody>
          <tbody *ngIf="displayMode==3">
            <tr>
              <td colspan="6"><div class="alert alert-danger alert-dark">{{'app.ServerError' | translate}}.</div></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="panel-footer margin-left-20 margin-top-20">
      <button class="btn btn-cancel" type="button" (click)="back()">{{'app.cancel' | translate}}</button>
    </div>
  </div>

  <div [hidden]="!formMode">
    <crm-save-hcp-brand-class #saveHcpClass></crm-save-hcp-brand-class>
  </div>
</div>
